import Headroom from "headroom.js";

/**
 * Setup Headroom.js
 */
const initializeHeadroom = (header) => {
  const headroomSettings = {
    offset: header.offsetHeight,
    classes: {
      initial: "is-loaded",
      pinned: "is-pinned",
      unpinned: "is-unpinned",
      top: "is-at-top",
      notTop: "is-not-at-top",
    },
  };

  new Headroom(header, headroomSettings).init();
};

export const enhancer = (header) => {
  initializeHeadroom(header);
};
